const convertBinaryToBool = (binary) => {
  if (binary === '' || binary === undefined || binary === null) return ''

  return Boolean(binary)
}

export default convertBinaryToBool
